module.exports = __webpack_public_path__ + "static/media/ic_how_to_claim.b0f509ff.svg";